export default __webpack_public_path__ + "static/media/four.e57ec492.jpeg";